document.addEventListener("DOMContentLoaded", function () {
    var buttons = document.querySelectorAll(".btnsquare");

    buttons.forEach(function (button) {
    button.addEventListener("click", function (event) {
        event.preventDefault();

        var dropup = this.closest(".box-menu-left, .box-menu-right");

        if (dropup.classList.contains("active")) {
        dropup.classList.remove("active");
        this.classList.remove("rotated");
        } else {
        dropup.classList.add("active");
        this.classList.add("rotated");
        }

        var menu = dropup.querySelector("ul");
        if (menu) {
        if (menu.style.display === "block") {
            menu.style.display = "none";
        } else {
            menu.style.display = "block";
        }
        }
    });
    });
});
